import {isOnline, loadAdminList, removeAdmin} from "../actions/userActions";
import AccessList from "../components/AccessList";
import {connect} from "react-redux";
import {push} from "react-router-redux";
import {isProcessing} from "../actions/processingActions";
import {PROC_LOAD_ACCESS} from "../actions";

const m2s = state => ({
	admins: state.user.list,
	user_id: state.user.data ? state.user.data.admin_id : null,
	isLoading: isProcessing(state, PROC_LOAD_ACCESS)
});

const m2d = dispatch => {
	dispatch(isOnline(() => {
		dispatch(loadAdminList());
	}));
	return {
		onLoad: () => dispatch(loadAdminList()),
		onDelete: (admin_id, onSuccess) => dispatch(removeAdmin(admin_id, onSuccess)),
		onPush: (to) => dispatch(push(to))
	};
};

export default connect(m2s, m2d)(AccessList);


// WEBPACK FOOTER //
// ./src/containers/AccessListController.js